export const FIELDS = [
  {
    name: 'name',
    type: 'text',
    position: '1/3',
  },
  {
    name: 'code',
    type: 'text',
    position: '3/5',
  },
  {
    name: 'regions',
    type: 'entity-select',
    fields: ['_id', 'name', 'subdivisions'],
    position: '5/7',
  },
  {
    name: 'description',
    type: 'text',
    position: '1/4',
  },
  {
    name: 'tokenType',
    label: 'Token Type',
    type: 'select',
    position: '4/7',
  },
  {
    name: 'actions',
    type: 'select',
    multi: true,
    position: '1/7',
  },
  {
    name: 'message',
    type: 'text',
    position: '1/7',
  },
  {
    name: 'tokens',
    label: 'Tokens List',
    type: 'none',
  },
]

export const INITIAL_STATE = {
  name: '',
  code: '',
  regions: [],
  description: '',
  tokenType: '',
  actions: '',
  tokens: '',
  logs: [],
}

// TOKENS RELATED:

export const TYPE = {
  BASE: 'BASE',
  ADDED: 'ADDED',
  REMOVED: 'REMOVED',
}

export const TOKEN_STATUS = {
  [TYPE.ADDED]: {
    class: TYPE.ADDED.toLocaleLowerCase(),
    icon: 'checkmark',
  },
  [TYPE.REMOVED]: {
    class: TYPE.REMOVED.toLocaleLowerCase(),
    icon: 'add',
  },
  [TYPE.BASE]: {
    class: TYPE.BASE.toLocaleLowerCase(),
    icon: 'delete',
  },
}

export const MAX_PAGE_SIZE = 64
export const MIN_BASE_ITEMS = 10

export const COLUMNS_COUNT = 4
